import { EMapTypes } from '../constants/map';
import { InfrastructureCategory, InfrastructureType } from '../store/map';
import { EInfrastructureType } from '../types';

export function getInfrastructureType(item: EInfrastructureType) {
  const keys = Object.keys(InfrastructureCategory).map(Number);

  return keys.find(
    (key: Exclude<InfrastructureType, InfrastructureType.Mixed>) => InfrastructureCategory[key] === item,
  );
}

export function coordinatesIsEqual(a: [number, number], b: [number, number]) {
  return a[0] === b[0] && a[1] === b[1];
}

export interface IGetStaticMapStylesParams {
  coordinates: {
    lat: number;
    lng: number;
  };
  size?: {
    width: number;
    height: number;
  };
  type?: EMapTypes;
}
